import { Grid } from '@mui/material';
import {
    HeaderSurveyLayout,
    PropsHeaderSurveyLayout,
} from './headerSurveyLayout';
import { FooterSurveyLayout } from './footerSurveyLayout';

interface Props extends PropsHeaderSurveyLayout {
    children: any;
}

export const SurveyLayout = ({
    children,
    title,
    logo,
    description,
    color,
    fontFamily,
}: Props) => {
    return (
        <div>
            <HeaderSurveyLayout
                title={title}
                logo={logo}
                color={color}
                description={description}
                fontFamily={fontFamily}
            />
            <Grid
                maxWidth="md"
                minHeight="30vh"
                flex={1}
                padding={{ xs: '20px', lg: '20px auto' }}
                margin="auto"
            >
                {children}
            </Grid>
            <FooterSurveyLayout />
        </div>
    );
};
